import React from "react";
import { BankAccountInterface } from "../../../interfaces/bank-account.interface";

interface BankAccountSectionProps {
  bankAccount: BankAccountInterface | null;
}

const BankAccountSection: React.FC<BankAccountSectionProps> = ({
  bankAccount,
}) => {
  return (
    <div className="px-4 pb-4">
      <h2 className="text-xl font-semibold text-yellow-500 text-left mb-4">
        Bank Account
      </h2>
      {!bankAccount ? (
        <div className="rounded-xl border border-gray-600 bg-gray-800/60 p-4 text-gray-500 text-sm">
          No bank account on file.
        </div>
      ) : (
        <div className="rounded-xl border border-gray-600 bg-gray-800/60 p-4 space-y-3 text-sm text-gray-200">
          <div className="flex flex-wrap items-center gap-2">
            <span
              className={`inline-flex px-3 py-1 rounded-full text-xs font-semibold ${
                bankAccount.isVerifiedByCashfree
                  ? "bg-green-500/20 text-green-300 border border-green-400/40"
                  : "bg-red-500/20 text-red-300 border border-red-400/40"
              }`}
            >
              {bankAccount.isVerifiedByCashfree ? "Verified" : "Not Verified"}
            </span>
            {bankAccount.beneficiary_status ? (
              <span className="text-xs text-gray-400">
                Beneficiary status: {bankAccount.beneficiary_status}
              </span>
            ) : null}
          </div>
          <p>
            <span className="font-semibold text-yellow-400">Account holder:</span>{" "}
            {bankAccount.name}
          </p>
          <p>
            <span className="font-semibold text-yellow-400">Account number:</span>{" "}
            {bankAccount.bankAccount}
          </p>
          <p>
            <span className="font-semibold text-yellow-400">IFSC:</span>{" "}
            {bankAccount.ifsc}
          </p>
          {bankAccount.phone ? (
            <p>
              <span className="font-semibold text-yellow-400">Phone:</span>{" "}
              {bankAccount.phone}
            </p>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default BankAccountSection;
